import axios from "axios"
import { Message } from "element-ui"
import { getToken } from "./token"

const baseURL = process.env.NODE_ENV === "production"
    // ? "http://120.48.53.21:9529/base/base"
    ? "/api"
    : "/api"

const service = axios.create({
    baseURL,
    timeout: 600000
})

service.interceptors.request.use(function (config) {
    if (getToken()) {
        config.headers.Authorization = localStorage.token
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

service.interceptors.response.use(function (response) {
    const res = response.data

    if (res.code !== 200) {
        if (res.code === 401) {
            Message({
                type: "warning",
                showClose: true,
                message: "登录状态已失效"
            })
            return Promise.reject("error")
        }

        if (res.code === 400) {
            Message({
                type: "warning",
                showClose: true,
                message: "账号或密码错误"
            })
            return Promise.reject("error")
        }
    }

    return response
}, function (error) {
    Message({
        message: "请求失败，请稍后重试",
        type: "error",
        duration: 5 * 1000
    })
    return Promise.reject(error)
})

export default service
